namespace MACRAIL {

/**
 * Create and show a modal dialog easily.
 */
export class EventEmitter {

    private eventListeners: EventList;

    public constructor() {
        this.eventListeners = {};
    }

    public on(eventName: string, callback: Function): void;
    public on(eventName: string, filter: string, callback: Function): void;
    public on(eventName: string, callbackOrFilter: string|Function, callback?: Function): void {

        if (!this.eventListeners[eventName]) {
            this.eventListeners[eventName] = {
                'callbacks': [],
                'filteredCallbacks': {},
            };
        }

        if (typeof callbackOrFilter === 'function') {
            this.eventListeners[eventName].callbacks.push(callbackOrFilter);
        } else {
            if (!this.eventListeners[eventName].filteredCallbacks[callbackOrFilter]) {
                this.eventListeners[eventName].filteredCallbacks[callbackOrFilter] = [];
            }
            this.eventListeners[eventName].filteredCallbacks[callbackOrFilter].push(callback);
        }

    }

    public trigger(eventName: string, data?: object): void;
    public trigger(eventName: string, filter: string, data?: object): void;
    public trigger(eventName: string, filterOrData: string|object, data?: object): void {
        if (!this.eventListeners[eventName]) {
            return;
        }

        if (filterOrData === undefined || typeof filterOrData === 'object') {
            for (let callback of this.eventListeners[eventName].callbacks) {
                callback(filterOrData);
            }
        } else {
            if (!this.eventListeners[eventName].filteredCallbacks[filterOrData]) {
                return;
            }
            for (let callback of this.eventListeners[eventName].filteredCallbacks[filterOrData]) {
                callback(data);
            }
        }
    }
}

// interf
// EventCallback: (data: object): void;

interface EventList {
    [index: string]: EventItem;
}

interface EventItem {
    callbacks: Function[];
    filteredCallbacks: FilteredEventCallbackList;
}

interface FilteredEventCallbackList {
    [index: string]: Function[];
}

}
